module.exports = __webpack_public_path__ + "static/fonts/roboto-v18-latin-regular-bafb105baeb22d965c70fe52ba6b49d9.woff";